import React, { Component } from 'react';
import SettingsPageLayout from './SettingsPageLayout';
import Dropdown from 'react-bootstrap/Dropdown';
import siteSetting from "../../config/env";
import {paymentActions, userActions} from "../../_actions";
import {connect} from "react-redux";
import animationData from '../../assets/animation-data/loader.json'
import {Close} from '../../component/SvgIcon';
import moment from 'moment';
import Lottie from 'react-lottie';
import { Modal } from "react-bootstrap";
import toast from '../shared/Toast';
import StripeStatusCard from './StripeStatusCard';
import { ResponsiveContainer, BarChart, Bar, XAxis, LabelList } from 'recharts';
import '../booking/ClientCheckout.css';
import './SettingsModern.css';
import coinAnimationData from '../../assets/animation-data/coin.json';
import LocationPayoutCard from '../multiLocation/LocationPayoutCard';
const defaultOptionsloti = {
    loop: true,
    autoplay: true, 
    animationData: coinAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};


// Emergency blanket kill-switch for bank changes (was a weekend fraud stopgap,
// 2026-06-20). FALSE = normal flow — "Add/Edit bank account" and "View Payouts
// on Stripe" run as before, gated per-owner by the backend merchantStatus
// approval gate (fail-open: only explicit pending/flagged owners are blocked).
// TRUE = hard-block ALL bank changes for everyone, regardless of status. Leave
// FALSE; flip TRUE only to instantly halt all bank changes in an incident.
const BANK_CHANGES_DISABLED = false;

class PayoutAccount extends Component{
    constructor(props){
        super(props);

        this.state = {
            bankAccount:'',
            bankName:'',
            bankAccountId:'',
            // Merchant approval state from Beu: '' | 'pending' | 'flagged'
            // ('established'/null => allowed). Drives the payout-account states.
            merchantStatus:'',
            currencySymbol:'',
            currency:'',
            balance:0,
            availablePayout:0,
            availableSoon:0,
            payoutList:[],
            totalCount:0,
            activePage: 1,
            payoutError:'',
            successMessage:'',
            isEditDropdownOpen: false,
            isLoader:true,
            showTooltip:false,
            exportPopup: false,
            selectedPayoutType:"instant",
            instantPaymentFee: 0,
            standardPaymentFee: 0,
            loading:false,
            paymentPopUp : false,
            instant_available : 0,
            allFeePopUp : false,
            selectedPayoutFee:{}
        }

        this.feeModal = this.feeModal.bind(this);

    }
    
    componentDidMount() {
        var self = this;
        if (localStorage.getItem('accessToken')) {
            self.payoutList();
            self.getData();
        } else {
            this.props.history.push('/')
        }
    }

    getData = () =>{
        let employmentType={};
        let params={
            defaultRedirectTo:localStorage.getItem('defaultRedirectTo')
        }
        params.latitude = siteSetting.default_latitude;
        params.longitude = siteSetting.default_longitude;
        var self = this;
        self.props.dispatch(paymentActions.getBank({}))
                .then(function (res){
                    // Get the currency and symbol from the hairdresser profile
                    const currency = self.props.user?.userInfo?.hairdresser?.currency || 'GBP';
                    const currencySymbol = self.props.user?.userInfo?.hairdresser?.currencySymbol || '£';
                    
                    self.setState({
                        bankAccount:self.props.bankDetails&&self.props.bankDetails.external_accounts&&self.props.bankDetails.external_accounts.data&&self.props.bankDetails.external_accounts.data.length>0?self.props.bankDetails.external_accounts.data[0]?.last4:'',
                        bankName:self.props.bankDetails?.external_accounts?.data&&self.props.bankDetails.external_accounts.data.length>0?self.props.bankDetails.external_accounts.data[0]?.bank_name:'',
                        bankAccountId:self.props.bankDetails?.external_accounts?.data&&self.props.bankDetails.external_accounts.data.length>0?self.props.bankDetails.external_accounts.data[0]?.id:'',
                        availablePayout:self.props.bankDetails?.balance?.available[0]?.amount || 0,
                        availableSoon:self.props.bankDetails?.balance?.pending[0]?.amount || 0,
                        currencySymbol: currencySymbol,
                        currency: currency,
                        instant_available:res?.data?.responseData?.result?.balance?.instant_available?.[0]?.amount || 0,
                        merchantStatus:res?.data?.responseData?.merchantStatus || '',
                    },function (){
                        self.setState({
                            isLoader:false
                        })
                    }, function(error) {
                        // Ensure loader is turned off even if there's an error
                        self.setState({
                            isLoader:false
                        })
                    })
                })
                .catch(function (err) {
                    console.error("Error fetching bank details:", err);
                    // Get the currency and symbol from the hairdresser profile even if bank details fail
                    const currency = self.props.user?.userInfo?.hairdresser?.currency || 'GBP';
                    const currencySymbol = self.props.user?.userInfo?.hairdresser?.currencySymbol || '£';
                    const bankError = (err && err.response && err.response.data && (err.response.data.error?.responseMessage || err.response.data.message)) || (err && err.message) || 'error';
                    
                    self.setState({
                        bankError,
                        isLoader: false,
                        currencySymbol: currencySymbol,
                        currency: currency
                    });
                })
            self.props.dispatch(userActions.profile(params))
                .then(function (response) {
                    console.log("response",response.data.data);
                    if(response.data.data) {
                        if(response.data.data.userInfo.hairdresser.isSalonOwner===1){
                            employmentType={ value: '1', label: 'Owner'}
                        }else if(response.data.data.userInfo.hairdresser.isSalonOwner===2){
                            employmentType={ value: '2', label: 'Account Manager'}
                        }else if(response.data.data.userInfo.hairdresser.isSalonOwner===0) {

                            if (response.data.data.userInfo.hairdresser.employmentTypeId === 1) {
                                employmentType = {value: '3', label: 'Employee'}
                            } else {
                                employmentType = {value: '4', label: 'Self Employee'}
                            }
                        }
                        self.setState(
                            {
                                employmentType:employmentType,
                                first_name: response.data.data.userInfo.first_name&&response.data.data.userInfo.first_name!==""?response.data.data.userInfo.first_name:response.data.data.userInfo.name,
                                last_name:response.data.data.userInfo.last_name,
                                email: response.data.data.userInfo.email,
                                phoneNumber: response.data.data.userInfo.phoneNumber?.toString() || '',
                                jobTitle: response.data.data.userInfo.hairdresser.jobTitle,
                                shortBio: response.data.data.userInfo.hairdresser.shortBio,
                                circleImagePrev:response.data.data.userInfo.userImage?.circleImage?response.data.data.userInfo.userImage.circleImage:require('../../assets/images/user-placeholder.png')
                            }
                        )
                    }
                })
                .catch(function (err) {
                    console.error("Error fetching user profile:", err);
                    // Continue with default values if profile fetch fails
                })
    }


    componentWillUnmount(){
        document.body.classList.remove('setting-temps-pages');
    }

    checkReadOnly(){
        if(this.props.user&&this.props.user.userInfo&&this.props.user.userInfo.hairdresser.isSalonOwner===1){
            return true;
        }else{
            return false;
        }
    }

    addbank=()=>{
        if (BANK_CHANGES_DISABLED) {
            toast.error('Adding or changing your payout bank account is temporarily unavailable. Please contact support.');
            return;
        }
        let self=this;
        self.props.dispatch(paymentActions.bankLink({}))
            .then(function (response) {
                if (response.data.statusCode===1) {
                    window.open(response.data.responseData.result.url,"_self");
                    return;
                }
                // Blocked or errored — SURFACE it (was silently swallowed) and,
                // if it's the Beu approval gate, reflect the under-review state.
                const msg = (response.data && (response.data.error?.responseMessage || response.data.message))
                    || 'We couldn’t open bank setup right now. Please try again.';
                toast.error(msg);
                if (/approval|review|awaiting/i.test(msg) && !self.state.merchantStatus) {
                    self.setState({ merchantStatus: 'pending' });
                }
            })
            .catch(function (err) {
                const msg = (err && err.response && err.response.data && (err.response.data.error?.responseMessage || err.response.data.message))
                    || 'Something went wrong opening bank setup. Please try again.';
                toast.error(msg);
            });
    }

    deleteBankAccount=()=>{
        let self=this;
        self.props.dispatch(paymentActions.deleteBankAccount({bankAccountId:this.state.bankAccountId}))
            .then(function (response) {
                console.log("response", response.data);
            });
    }

    payoutList=()=>{
        let self=this;
        self.props.dispatch(paymentActions.payoutList({}))
            .then(function (response) {
                console.log("payoutList", response.data);
                if (response.data.statusCode===1) {
                    self.setState({
                        totalCount:0,
                        payoutList:response.data?.responseData?.result?.data || [],
                    })
                }else{
                    self.setState({
                        payoutList: []
                    })
                }
            })
            .catch(function (err) {
                console.error("Error fetching payout list:", err);
                self.setState({
                    payoutList: []
                });
            });
    }

    showTooltip=()=>{
        this.setState({
            showTooltip:true
        })
     }
     hideTooltip=()=>{
        this.setState({
            showTooltip:false
        })
     }
    payPopUp = ()=>{
        let self = this;
        const instantFee = siteSetting.payout.instantPaymentFee;
        self.setState({
            payoutAmount: this.state?.instant_available/100,
            instantPaymentFee: (Number(this.state?.instant_available)/100 * instantFee).toFixed(2),
            exportPopup: true,
            loading:false
        })
      }

      successPayment = ()=>{
        const { selectedPayoutType } = this.state;
        const payoutAmount = parseFloat(document.getElementById("payoutAmount").value);
      
        if (!selectedPayoutType || isNaN(payoutAmount) || payoutAmount <= 0 || payoutAmount === 0) {
            toast.error("Please enter a valid amount.")
          this.setState({
            successMessage: "",
          });
          return;
        }
        const availableAmount = this.state?.availablePayout/100; 
            if (payoutAmount > availableAmount) {
            toast.error("Amount exceeds available funds.");
            this.setState({
            successMessage: "",
            });
                return;
            }
        let self = this;
        self.payoutList()
        self.setState({
            loading:false,
            exportPopup:false
        })
        
      }
    
      instantPayout = () => {
       
        const { selectedPayoutType } = this.state;
        const payoutAmount = parseFloat(document.getElementById("payoutAmount").value);
      
        if (!selectedPayoutType || isNaN(payoutAmount) || payoutAmount <= 0 || payoutAmount === 0) {
            toast.error("Please enter a valid amount.")
          this.setState({
            successMessage: "",
          });
          return;
        }

        const availableAmount = this.state?.availablePayout/100; 
            // if (payoutAmount > availableAmount) {
            // toast.error("Amount exceeds available funds.");
            // this.setState({
            // successMessage: "",
            // });
            //     return;
            // }
      
        let data = {
            amount:payoutAmount,
            paymentType:selectedPayoutType,
          }
          
      
        let self = this;
        self.setState({
          payoutError: "",
          successMessage: "",
          loading:true  ,
        });
        self.props.dispatch(paymentActions.instantPayout(data))
          .then(function (response) {
            if (response.data.statusCode === 1) {
              self.setState({
                payoutError: "", 
                paymentPopUp:true,
                exportPopup:false
              });
            } else {
                toast.error(response.data.error.errors.responseMessage)
              self.setState({
                successMessage: "",
                loading:false
              });
            }
          })
          .catch(function (error) {
            toast.error("An error occurred while processing the payout.")
            self.setState({
              successMessage: "", 
            }).finally(function(){
                self.setState({
                    loading:false
                })
            })
          });
      };
      
      handleInstantPayout = (e) => {
        const instantFee = siteSetting.payout.instantPaymentFee;
        const availablePayout = (this.state.instant_available).toFixed(2);
        const errorMessageElement = document.getElementById("error_message");
        const enteredAmount = Number(e.target.value);
        const instantPaymentFee = (enteredAmount * instantFee).toFixed(2);
        this.setState({
          payoutAmount: enteredAmount ? enteredAmount : "",
          instantPaymentFee: instantPaymentFee,
        });
    
        if (errorMessageElement === null) {
          console.error("Error message element not found");
          return;
        }
    
        if (enteredAmount < 1) {
            e.preventDefault();
            toast.error("Payout amount must be greater than 0");
          } else if (availablePayout === 0) {
            e.preventDefault();
            toast.error("No funds available for payout.");
          } else if (enteredAmount > availablePayout) {
            e.preventDefault();
            toast.error("Payout amount exceeds available funds");
          } else {
            errorMessageElement.textContent = "Payment success";
          }
    
        setTimeout(() => {
          errorMessageElement.textContent = "";
        }, 3000);
      };

      handleStandardPayout = (e) => {
        const instantFee = siteSetting.payout.standardPaymentFee;
        const extraStandardPaymentFee = siteSetting.payout.extraStandardPaymentFee;
        const availablePayout = this.state.availablePayout;
        const errorMessageElement = document.getElementById("error_message");
        const enteredAmount = Number(e.target.value);
        const standardPaymentFee =((enteredAmount * instantFee) + extraStandardPaymentFee).toFixed(2);
        const standardPayoutAmount = (enteredAmount - parseFloat(standardPaymentFee)).toFixed(2);
        this.setState({
          payoutAmount: enteredAmount ? enteredAmount : "",
          standardPaymentFee: standardPaymentFee,
          standardPayoutAmount : standardPayoutAmount,
        });
    
        if (errorMessageElement === null) {
          console.error("Error message element not found");
          return;
        }
    
        if (enteredAmount < .01) {
            e.preventDefault();
            toast.error("Payout amount must be greater than 0");
          } else if (availablePayout === 0) {
            e.preventDefault();
            toast.error("No funds available for payout.");
          } else if (enteredAmount > availablePayout) {
            e.preventDefault();
            toast.error("Payout amount exceeds available funds");
          } else {
            errorMessageElement.textContent = "Payment success";
          }
    
        setTimeout(() => {
          errorMessageElement.textContent = "";
        }, 3000);
      };

      
    openEditMobileDropdown = ()=>{
        this.setState({
            isEditDropdownOpen: !this.state.isEditDropdownOpen
        })
    }

    createLoginLink=()=>{
        if (BANK_CHANGES_DISABLED) {
            toast.error('Managing your payout bank account is temporarily unavailable. Please contact support.');
            return;
        }
        let self=this;
        self.props.dispatch(paymentActions.createLoginLink({}))
            .then(function (response) {
                console.log("response", response.data);
                if (response.data.statusCode===1) {
                    window.open(response.data.responseData.result.url,"_blank");
                }else{

                }
            });
    }
     handleminus = (value) =>{
        const standardFee = siteSetting.payout.standardPaymentFee;
        const extraStandardPaymentFee = siteSetting.payout.extraStandardPaymentFee;
        const result = (value - ((value * standardFee) + extraStandardPaymentFee))  
        return result >= 0 ? result.toFixed(2) : "0.00";
    }

    
    onExportCancelled = () => {
        this.setState({ exportPopup: false});
      };

      onPaymentContinue = () =>{
        let self = this;
        self.setState({ paymentPopUp: false ,exportPopup: false});
         self.payoutList()
         self.getData()
      }
    
      handlePayoutTypeChange = (clickedPayoutType) => {
        const { selectedPayoutType,availablePayout } = this.state;
      
        if (clickedPayoutType !== selectedPayoutType) {
          this.setState({ 
            selectedPayoutType: clickedPayoutType,
            payoutAmount: clickedPayoutType === "standard"?this.state?.availablePayout/100:this.state?.instant_available/100,
            instantPaymentFee: this.state?.instantPaymentFee,
            standardPaymentFee: this.state?.standardPaymentFee,
          });
          if(clickedPayoutType === "standard"){
            const standardPayoutAmount = (availablePayout - parseFloat(this.state.standardPaymentFee)) / 100;
            this.setState({ payoutAmount: this.handleminus(standardPayoutAmount )});
          }
        }
    };

    closeFeePopup = () =>{
        let self = this;
        self.setState({selectedPayoutFee:{}, allFeePopUp: false});
    }
    feeModal = (data) =>{
        if (!data) {
            console.error("Fee modal called with invalid data");
            return;
        }
        let self = this;
        self.setState({ selectedPayoutFee:data,allFeePopUp: true});
    }
   

    render(){
        const { selectedPayoutType } = this.state;
        const isStandardSelected = selectedPayoutType === "standard";
        return(
            <SettingsPageLayout activeTab="payout-account" {...this.props}>
                {/* At-a-glance Stripe status: approval, details, bank, payouts. Reuses the getBank response above. */}
                {!this.state.isLoader && (
                    <StripeStatusCard
                        own={{ account: this.props.bankDetails, merchantStatus: this.state.merchantStatus, error: this.state.bankError }}
                        onAction={(s) => (s.key === 'unknown' ? window.location.reload() : this.addbank())}
                    />
                )}
                {/* Multi-location owners: which bank this location pays into, and its own. */}
                {!this.state.isLoader && <LocationPayoutCard returnPath="/settings/payout-account" onChanged={() => window.location.reload()} />}
                {this.state.isLoader ? (
                    <div className="settings-card">
                        <div className="settings-loading">
                            <Lottie options={defaultOptions} height={50} width={200} />
                            <p>Loading Data...</p>
                        </div>
                    </div>
                ) : this.state.bankAccountId === '' || this.state.bankAccountId === undefined ? (
                    (this.state.merchantStatus === 'pending' || this.state.merchantStatus === 'flagged') ? (
                        // Under-review state — Beu hasn't approved this account for
                        // payouts yet, so we explain rather than dead-end on a button.
                        <div className="settings-card" style={{textAlign: 'center', padding: '48px 32px'}}>
                            <div style={{fontSize: '40px', marginBottom: '16px'}}>{this.state.merchantStatus === 'flagged' ? '🔍' : '⏳'}</div>
                            <span style={{display: 'inline-block', padding: '5px 14px', borderRadius: 999, fontSize: '12px', fontWeight: 600, background: '#FEF0C7', color: '#B54708', marginBottom: '16px'}}>
                                Awaiting Beu approval
                            </span>
                            <h2 style={{fontSize: '20px', fontWeight: 600, color: '#333', marginBottom: '12px'}}>Your account is under review</h2>
                            <p style={{fontSize: '14px', color: '#888', maxWidth: '440px', margin: '0 auto', lineHeight: 1.6}}>
                                {this.state.merchantStatus === 'flagged'
                                    ? 'We’ve spotted a change on your account and are reviewing it to keep your payouts secure. You’ll be able to manage your payout bank again once it’s approved — we’ll email you.'
                                    : 'Thanks for signing up! We’re reviewing your account before you can add a payout bank and take money. This usually takes one business day — we’ll email you as soon as you’re approved.'}
                            </p>
                            <p style={{fontSize: '13px', color: '#aaa', margin: '16px 0 0'}}>Need help? Email <a href="mailto:info@beuapp.com" className="auth-link">info@beuapp.com</a></p>
                        </div>
                    ) : (
                        <div className="settings-card" style={{textAlign: 'center', padding: '48px 32px'}}>
                            <img src={require('../../assets/images/addAcnt-bg.jpg')} style={{maxWidth: '280px', width: '100%', borderRadius: '12px', marginBottom: '24px'}} alt="Add Bank Account" />
                            <h2 style={{fontSize: '20px', fontWeight: 600, color: '#333', marginBottom: '12px'}}>Add Bank Account</h2>
                            <p style={{fontSize: '14px', color: '#888', maxWidth: '400px', margin: '0 auto 24px', lineHeight: 1.5}}>Add your bank account to unlock Beu's full functionality, take deposits and receive payment with the Beu card reader.</p>
                            <button className="settings-btn settings-btn-primary" onClick={() => this.addbank()}>Add Bank Account</button>
                        </div>
                    )
                ) : (
                    <div>
                        {/* Payout Overview */}
                        <div className="payout-overview">
                            <div className="payout-hero-card">
                                <div className="payout-hero-card-bg" />
                                <div className="payout-hero-card-content">
                                    <div className="payout-hero-top">
                                        <div className="payout-hero-chip">
                                            <svg width="28" height="20" viewBox="0 0 32 24" fill="none">
                                                <rect x="0.5" y="0.5" width="31" height="23" rx="3.5" fill="#e8c547" stroke="#d4a017"/>
                                                <line x1="0" y1="8" x2="32" y2="8" stroke="#d4a017" strokeWidth="0.5"/>
                                                <line x1="0" y1="12" x2="32" y2="12" stroke="#d4a017" strokeWidth="0.5"/>
                                                <line x1="0" y1="16" x2="32" y2="16" stroke="#d4a017" strokeWidth="0.5"/>
                                                <line x1="11" y1="0" x2="11" y2="24" stroke="#d4a017" strokeWidth="0.5"/>
                                                <line x1="21" y1="0" x2="21" y2="24" stroke="#d4a017" strokeWidth="0.5"/>
                                            </svg>
                                        </div>
                                        <Dropdown>
                                            <Dropdown.Toggle id="dropdown-basic" className="payout-hero-icon-btn payout-dropdown-toggle">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => this.addbank()}>Edit Payout Account</Dropdown.Item>
                                                <Dropdown.Item onClick={() => this.createLoginLink()}>View Payouts on Stripe</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                    <div className="payout-hero-balance">
                                        <p className="payout-hero-balance-label">Available Balance</p>
                                        <h2 className="payout-hero-balance-amount">{this.state.currencySymbol}{this.handleminus(this.state.availablePayout/100)}</h2>
                                    </div>

                                    <div className="payout-hero-bottom">
                                        <div>
                                            <p className="payout-hero-bank-label">Bank Account</p>
                                            <p className="payout-hero-bank-value">{this.state.bankName?.toLowerCase()} &bull;&bull;&bull;&bull; {this.state.bankAccount}</p>
                                        </div>
                                        <div>
                                            <p className="payout-hero-bank-label">Available Instantly</p>
                                            <p className="payout-hero-bank-value">{this.state.currencySymbol}{(this.state.instant_available/100).toFixed(2)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="payout-side-panel">
                                <div className="payout-chart-header">
                                    <h3 className="payout-chart-title">Payouts</h3>
                                    <span className="payout-side-link" onClick={() => this.showTooltip()}>
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                                        How payouts work
                                    </span>
                                </div>
                                <div className="payout-chart">
                                    {(() => {
                                        const data = [];
                                        const now = moment();
                                        for (let i = 5; i >= 0; i--) {
                                            const m = now.clone().subtract(i, 'months');
                                            data.push({ key: m.format('YYYY-MM'), month: m.format('MMM'), amount: 0 });
                                        }
                                        if (Array.isArray(this.state.payoutList)) {
                                            this.state.payoutList.forEach(p => {
                                                const key = moment.unix(p.created).format('YYYY-MM');
                                                const entry = data.find(d => d.key === key);
                                                if (entry) entry.amount += (p.amount || 0) / 100;
                                            });
                                        }
                                        const sym = this.state.currencySymbol;
                                        const renderBarLabel = (props) => {
                                            const { x, y, width, value } = props;
                                            if (!value || value === 0) return null;
                                            return (
                                                <text x={x + width / 2} y={y - 8} textAnchor="middle" fontSize={11} fontWeight={600} fill="#1a1a1a">
                                                    {sym}{value >= 1000 ? `${(value/1000).toFixed(1)}k` : value.toFixed(0)}
                                                </text>
                                            );
                                        };
                                        return (
                                            <ResponsiveContainer width="100%" height="100%">
                                                <BarChart data={data} margin={{ top: 24, right: 8, bottom: 0, left: 8 }} barCategoryGap="30%">
                                                    <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#999', fontWeight: 500 }} dy={8} />
                                                    <Bar dataKey="amount" fill="#1c1c2e" radius={[6, 6, 0, 0]} maxBarSize={36}>
                                                        <LabelList content={renderBarLabel} />
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        );
                                    })()}
                                </div>
                                <button className="payout-withdraw-btn" onClick={() => this.payPopUp()}>Withdraw</button>
                            </div>

                            {this.state.showTooltip && (
                                <div className="payout-info-banner">
                                    <span className="payout-info-close" onClick={() => this.hideTooltip()}><Close/></span>
                                    <p>Your first payout is typically available 7 days after you add your bank account and take your first successful payment on Stripe. This waiting period can be up to 14 days for businesses in certain industries.</p>
                                    <a href="https://support.stripe.com/topics/payouts" target="_blank" rel="noopener noreferrer" className="payout-info-link">Learn more</a>
                                </div>
                            )}
                        </div>

                        {/* Withdrawal History */}
                        <div className="payout-history-card">
                            <div className="payout-history-header">
                                <h2>Withdrawal History</h2>
                            </div>
                            <table className="payout-history-table">
                                <thead>
                                    <tr>
                                        <th style={{width: '40%'}}>Withdrawal</th>
                                        <th style={{width: '20%'}}>Status</th>
                                        <th style={{width: '20%'}}>Type</th>
                                        <th style={{width: '20%', textAlign: 'right'}}>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(this.state.payoutList) && this.state.payoutList.length > 0 ?
                                        this.state.payoutList
                                            .slice((this.state.activePage - 1) * 10, this.state.activePage * 10)
                                            .map((data, i) => (
                                            <tr key={i} className="payout-history-row" onClick={() => this.feeModal(data)}>
                                                <td>
                                                    <div className="payout-row-primary">
                                                        <div className={`payout-row-avatar ${data?.status === 'paid' ? 'payout-row-avatar--paid' : 'payout-row-avatar--transit'}`}>
                                                            {data?.status === 'paid' ? (
                                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                                                            ) : (
                                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                                                            )}
                                                        </div>
                                                        <div className="payout-row-info">
                                                            <span className="payout-row-name">{moment.unix(data.created).format("ddd, DD MMM YYYY")}</span>
                                                            <span className="payout-row-sub">Arrives {moment.unix(data.arrival_date).format("DD MMM YYYY")}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className={`settings-badge ${data?.status === 'paid' ? 'settings-badge-default' : 'settings-badge-info'}`}>
                                                        {data?.status === 'in_transit' ? 'In transit' : data?.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="payout-row-method">{data?.method}</span>
                                                </td>
                                                <td style={{textAlign: 'right'}}>
                                                    <div className="payout-row-info" style={{alignItems: 'flex-end'}}>
                                                        <span className="payout-row-amount">{this.state.currencySymbol}{(data.amount / 100).toFixed(2)}</span>
                                                        <span className="payout-row-fee">Fee: {this.state.currencySymbol}{(data.payoutFee / 100).toFixed(2)}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                        :
                                        <tr>
                                            <td colSpan={4}>
                                                <div className="settings-empty"><p>No withdrawal history.</p></div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                            {this.state.payoutList.length > 10 && (
                                <div className="payout-pagination">
                                    <button
                                        className="payout-page-btn"
                                        disabled={this.state.activePage === 1}
                                        onClick={() => this.setState({ activePage: this.state.activePage - 1 })}
                                    >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
                                    </button>
                                    <span className="payout-page-info">
                                        {this.state.activePage} of {Math.ceil(this.state.payoutList.length / 10)}
                                    </span>
                                    <button
                                        className="payout-page-btn"
                                        disabled={this.state.activePage >= Math.ceil(this.state.payoutList.length / 10)}
                                        onClick={() => this.setState({ activePage: this.state.activePage + 1 })}
                                    >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Payout Popup */}
                        {this.state.exportPopup && (
                            <div className="cancel-booking-overlay" onClick={this.onExportCancelled}>
                                <div className="cancel-booking-sheet payout-sheet" onClick={e => e.stopPropagation()}>
                                    <div className="cancel-booking-header">
                                        <div className="cancel-booking-header-spacer" />
                                        <h2 className="cancel-booking-header-title">Payout Funds</h2>
                                        <button className="cancel-booking-nav-btn" onClick={this.onExportCancelled} aria-label="Close">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1L13 13M1 13L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                        </button>
                                    </div>
                                    <div className="payout-sheet-body">
                                        <div className="payout-type-cards">
                                            <div className={`payout-type-card ${!isStandardSelected ? 'payout-type-card-selected' : ''}`} onClick={() => this.handlePayoutTypeChange("instant")}>
                                                <input type="radio" value="instant" name="payoutType" className="payout-radio" checked={!isStandardSelected} readOnly />
                                                <div>
                                                    <span className="payout-type-label">Instant</span>
                                                    <p className="payout-type-desc">Up to {this.state.currencySymbol}{(this.state.instant_available/100).toFixed(2)} available and arrives instantly</p>
                                                </div>
                                            </div>
                                            {this.props.bankDetails?.settings?.payouts?.schedule?.interval === "manual" && (
                                                <div className={`payout-type-card ${isStandardSelected ? 'payout-type-card-selected' : ''}`} onClick={() => this.handlePayoutTypeChange("standard")}>
                                                    <input type="radio" value="standard" name="payoutType" className="payout-radio" checked={isStandardSelected} readOnly />
                                                    <div>
                                                        <span className="payout-type-label">Standard</span>
                                                        <p className="payout-type-desc">Up to {this.state.currencySymbol}{this.handleminus(this.state.availablePayout/100)} available and arrives in 2-3 business days</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {selectedPayoutType === "instant" && (
                                            <div className="payout-details">
                                                <div className="payout-detail-row"><span className="payout-detail-label">Available instantly</span><span className="payout-detail-value">{this.state.currencySymbol}{(this.state.instant_available/100).toFixed(2)}</span></div>
                                                <div className="payout-detail-row"><span className="payout-detail-label">Amount to pay out</span><span className="payout-detail-value"><span className="payout-currency-input"><span className="payout-currency-symbol">{this.state.currencySymbol}</span><input type="number" id="payoutAmount" value={this.state.payoutAmount} onChange={this.handleInstantPayout} className="payout-amount-input" /></span></span></div>
                                                <div className="payout-detail-row"><span className="payout-detail-label">Instant payout fee</span><span className="payout-detail-value">{this.state.currencySymbol}{this.state.instantPaymentFee}</span></div>
                                                <div className="payout-detail-row"><span className="payout-detail-label">Send payment to</span><span className="payout-detail-value payout-bank">{this.state.bankName} &#9679;&#9679;&#9679;&#9679; {this.state.bankAccount}</span></div>
                                            </div>
                                        )}
                                        {selectedPayoutType === "standard" && (
                                            <div className="payout-details">
                                                <div className="payout-detail-row"><span className="payout-detail-label">Available balance</span><span className="payout-detail-value">{this.state.currencySymbol}{this.handleminus(this.state.availablePayout/100)}</span></div>
                                                <div className="payout-detail-row"><span className="payout-detail-label">Amount to pay out</span><span className="payout-detail-value"><span className="payout-currency-input"><span className="payout-currency-symbol">{this.state.currencySymbol}</span><input type="number" id="payoutAmount" value={this.state.payoutAmount} onChange={this.handleStandardPayout} className="payout-amount-input" /></span></span></div>
                                                <div className="payout-detail-row"><span className="payout-detail-label">Send payment to</span><span className="payout-detail-value payout-bank">{this.state.bankName} &#9679;&#9679;&#9679;&#9679; {this.state.bankAccount}</span></div>
                                            </div>
                                        )}
                                        {this.state.payoutError && <p className="payout-error">{this.state.payoutError}</p>}
                                        {this.state.successMessage && <p className="payout-success">{this.state.successMessage}</p>}
                                        <div className="payout-actions">
                                            <button className={`cancel-booking-btn noshow-btn-confirm ${this.state.loading ? 'loading' : ''}`} onClick={() => this.instantPayout()} disabled={this.state.loading}>
                                                {this.state.loading ? 'Processing...' : <>Pay out {this.state.currencySymbol}{this.state.payoutAmount !== 0 ? Number(this.state.payoutAmount).toFixed(2) : '0.00'}</>}
                                            </button>
                                            <button className="cancel-booking-btn cancel-booking-btn-secondary" onClick={this.onExportCancelled}>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Success Popup */}
                        {this.state.paymentPopUp && (
                            <div className="cancel-booking-overlay" onClick={() => this.onPaymentContinue()}>
                                <div className="cancel-booking-sheet payout-sheet" onClick={e => e.stopPropagation()}>
                                    <div className="payout-success-body">
                                        <div className="payout-success-animation"><Lottie options={defaultOptionsloti} height={180} width={180} /></div>
                                        <h2 className="payout-success-title">Payout Successful</h2>
                                        <p className="payout-success-text">
                                            {this.state.selectedPayoutType === "instant"
                                                ? <>{this.state.currencySymbol}{this.state.payoutAmount !== 0 ? Number(this.state.payoutAmount).toFixed(2) : '0.00'} instantly paid out to your account</>
                                                : <>{this.state.currencySymbol}{this.state.payoutAmount !== 0 ? Number(this.state.payoutAmount).toFixed(2) : '0.00'} is on the way to your account and will arrive in 2-3 business days</>
                                            }
                                        </p>
                                        <div className="payout-actions">
                                            <button className="cancel-booking-btn noshow-btn-confirm" onClick={() => this.onPaymentContinue()}>Continue</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Fee Modal */}
                        <Modal blurClass="blure_bg" centered show={this.state.allFeePopUp} onHide={this.closeFeePopup} size="lg" className='fee_modal'>
                            <Modal.Header closeButton />
                            <Modal.Body>
                                <div style={{textAlign: 'center', padding: '16px 0'}}>
                                    <h3 style={{fontSize: '18px', fontWeight: 600, marginBottom: '20px'}}>Fee Details</h3>
                                    {this.state.selectedPayoutFee.feeBookingId && this.state.selectedPayoutFee.feeBookingId.length > 0 ? (
                                        <div style={{display: 'flex', justifyContent: 'center', gap: '12px'}}>
                                            <span style={{fontWeight: 500}}>Booking Id:</span>
                                            <span>{this.state.selectedPayoutFee.feeBookingId}</span>
                                        </div>
                                    ) : (
                                        <p style={{color: '#888'}}>Fee settlement is pending</p>
                                    )}
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                )}
            </SettingsPageLayout>
        )
    }

}

function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(PayoutAccount);
